<template>
  <div 
    :class="{'is-popup': popup, 'page': true}"
    >

    <header class="hd">
      <h3 class="ttl">
        Notifications
        <template v-if="popup">
          <NuxtLink to="/notifications" class="all">Show all</NuxtLink>
        </template>
      </h3>
      <div class="actions">
        <UiButton
          :tag="'button'"
          :type="'link'"
          ico="icon-check-double"
          name="Mark all as read"
          aria-label="Mark all as read"
          @click="markAllAsRead"
        /> 
        <UiButton
          :tag="'NuxtLink'"
          :type="'link'"
          :to="useAuth().getLink() + '/settings/notifications'"
          ico="icon-setting"
          name="Settings"
        />
      </div>
    </header>



    <NotificationTabs
      v-model="activeTab"
      :counts="tabCounts"
      @update:modelValue="switchTab"
    />

    <div class="lst">

      <NotificationList
        v-if="NotificationChannel.Direct === activeTab"
        :channel="NotificationChannel.Direct"
        :auto-load="false"
        :is-popup="popup"
        ref="listRefDirect"
      />
      <NotificationList
        v-if="NotificationChannel.Following === activeTab"
        :channel="NotificationChannel.Following"
        :auto-load="false"
        :is-popup="popup"
        ref="listRefFollowing"
      />
      <!-- <NotificationList
        v-if="NotificationChannel.Community === activeTab"
        :channel="NotificationChannel.Community"
        :auto-load="false"
        ref="listRefCommunity"
      /> -->
    </div>

  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { onClickOutside } from '@vueuse/core'
import UiButton from '~/components/ui/Button.vue'
import NotificationTabs from './NotificationTabs.vue'
import NotificationList from './NotificationList.vue'
import { usePopupPosition } from './usePopupPosition'
import { NotificationChannel } from '@/types/notification'

const { top, right, isHidden } = usePopupPosition()
const { 
  popupVisible, 
  tabCounts,
  loadNotificationGroups,
  initializeNotifications
} = useNotifications()

const props = defineProps<{
  popup?: boolean
}>()

const activeTab = ref<NotificationChannel>(NotificationChannel.Direct)
const listRefDirect = ref<any>(null)
const listRefFollowing = ref<any>(null)
const listRefCommunity = ref<any>(null)
const isInitialized = ref(false)

const switchTab = (newTab: NotificationChannel) => {
  activeTab.value = newTab
}

const onListInitialized = () => {
  isInitialized.value = true
}

const markAllAsRead = async () => {
  
  if (!await useUiModalConfirm().confirm('Mark all as read?'))
    return;

  useNotifications().markAllAsRead()
}

// Initialize notifications when popup is first opened
onMounted(async () => {
  if (!isInitialized.value) {
    // await initializeNotifications()
    // isInitialized.value = true

    useNotifications().loadNumbers()
  }
})

// Close popup when clicking outside
const popupRoot = ref(null)
onClickOutside(popupRoot, () => {
  popupVisible.value = false
})
</script>




<style scoped>

.hd{ display:flex; align-items:center; justify-content:space-between; padding:5px 16px; }
.ttl{ font-size:16px; font-weight:600; color:var(--text-primary); }
.actions{ display:flex; gap:8px; }
.actions :deep(i){ color:var(--text-primary); font-size:16px; }

.popup-fade-enter-active,
.popup-fade-leave-active{ transition:opacity 150ms ease,transform 150ms ease; }
.popup-fade-enter-from,
.popup-fade-leave-to{ opacity:0; transform:scale(.95); }

.is-popup .lst{ 

  overflow-y: auto; 
}
.page{
  display:flex;
  flex-direction:column;
  height: 100%;
}
.page :deep(.tbs_menu){
  box-shadow: inset 0 -2px 0 0 #dadada;
}

.ttl .all{
  opacity: 0.5;
  margin-left: 20px;
  font-size: 0.8rem;
  text-transform: uppercase;
}

</style>

